import { render, staticRenderFns } from "./veStuLiteraryAwardItemShow.vue?vue&type=template&id=c8fcf390&scoped=true"
import script from "./veStuLiteraryAwardItemShow.vue?vue&type=script&lang=js"
export * from "./veStuLiteraryAwardItemShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fcf390",
  null
  
)

export default component.exports